<div class="bolt-container">
    <div class="bolt-space-bottom-md"></div>
    <bolt-breadcrumbs
        class="bolt-space-bottom-md"
        currentleveltext="{{currentPage | titlecase}}"
        iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
            <a [routerLink]="bc.link">{{bc.name}}</a>
        </li>
    </bolt-breadcrumbs>

  <!-- Updates component -->
  <div *ngIf="currentPage === 'Updates'">
    <is-claim-updates *ngIf="claimNumber" [useCaching]="true" [claimNumber]="claimNumber"></is-claim-updates>
  </div>

  <!-- Documents component -->
  <div *ngIf="currentPage === 'Documents'">
    <is-documents *ngIf="claimNumber" [useCaching]="true" [claimNumber]="claimNumber" [displayUnregistered]="isUnregisteredUser"></is-documents>
  </div>

  <!-- Coverages component -->
  <div *ngIf="currentPage === 'Coverages'">
    <is-coverages *ngIf="claimNumber" [useCaching]="true" [incidentDate]="incidentDate" [claimNumber]="claimNumber" [displayUnregistered]="isUnregisteredUser"></is-coverages>
  </div>
  <!-- Contractors component -->
  <div *ngIf="currentPage === 'Contractors'">
    <is-contractors *ngIf="claimNumber" [useCaching]="true" [claimNumber]="claimNumber"></is-contractors>
  </div>

  <!-- Payments component -->
   <div *ngIf="currentPage === 'Payments'">
    <is-payments *ngIf="claimNumber" [useCaching]="true" [claimNumber]="claimNumber" [displayUnregistered]="isUnregisteredUser"></is-payments>
  </div>

  <!-- Support component -->
  <div *ngIf="currentPage === 'Support'">
    <is-support *ngIf="claimNumber" [useCaching]="true" [claimNumber]="claimNumber"></is-support>
  </div>
</div>
<bolt-button-bar>
    <bolt-button slot="back" type="solid" (click)="goBack()">Back</bolt-button>
</bolt-button-bar>
